import { dateToView } from "helpers/date";
import { formatNumber } from "helpers/system";
import React from "react";

const toRateNumber = (value) => {
    if (value === null || value === undefined || (typeof value === "string" && value.trim() === "")) {
        return null;
    }

    const number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : null;
};

/**
 * Компонент для отображения информации о средней ставке по направлению
 * Используется в форме заявки при создании/редактировании точек маршрута
 *
 * @param {Object} props
 * @param {number|null} props.averageRateByDestination - Рыночная ставка в руб/км или null
 * @param {string|null} props.averageRateDate - Дата расчёта ставки в формате ISO string
 * @param {number|null} props.bidAverageRate - Итоговая ставка заявки в руб/км или null
 * @param {Object|null} props.comparison - Результат сравнения ставок
 */
export default function AverageRateInfo({ averageRateByDestination, averageRateDate, bidAverageRate, comparison }) {
    const marketRate = toRateNumber(averageRateByDestination);
    const requestRate = toRateNumber(bidAverageRate);

    if (marketRate === null && requestRate === null) {
        return null;
    }

    return (
        <div className="average-rate-info">
            <div className="average-rate-info__title pb-1">Ставки по маршруту</div>
            {marketRate !== null && (
                <div className="average-rate-info__section pb-1">
                    <div className="average-rate-info__label">Рыночная ставка</div>
                    <div className="average-rate-info__value">{formatNumber(marketRate)} руб/км</div>
                    {averageRateDate && (
                        <div className="average-rate-info__date">Расчёт на: {dateToView(averageRateDate)}</div>
                    )}
                </div>
            )}
            {requestRate !== null && (
                <div className="average-rate-info__section">
                    <div className="average-rate-info__label">Ставка заявки</div>
                    <div className="average-rate-info__value">{formatNumber(requestRate)} руб/км</div>
                </div>
            )}
            {marketRate !== null && requestRate !== null && comparison && (
                <div className={`average-rate-info__status ${comparison.textClassName}`}>{comparison.text}</div>
            )}
        </div>
    );
}
